import { Download, Plus, Upload } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../api';
import ProveedorForm from './ProveedorForm';

export default function Proveedores() {
  const [proveedores, setProveedores] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [subiendo, setSubiendo] = useState(false);
  const inputArchivoRef = useRef(null);

  function cargar() {
    setCargando(true);
    api.get('/proveedores/').then((res) => setProveedores(res.data)).finally(() => setCargando(false));
  }

  useEffect(() => {
    cargar();
  }, []);

  async function alternarActivo(proveedor) {
    try {
      const res = await api.patch(`/proveedores/${proveedor.id}/`, { activo: !proveedor.activo });
      setProveedores((prev) => prev.map((p) => (p.id === proveedor.id ? res.data : p)));
    } catch {
      toast.error('No se pudo actualizar el proveedor.');
    }
  }

  function alGuardar() {
    setMostrarForm(false);
    setEditando(null);
    cargar();
  }

  async function descargarPlantilla() {
    const res = await api.get('/proveedores/plantilla-csv/', { responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const enlace = document.createElement('a');
    enlace.href = url;
    enlace.download = 'plantilla_proveedores.csv';
    document.body.appendChild(enlace);
    enlace.click();
    enlace.remove();
    window.URL.revokeObjectURL(url);
  }

  async function subirCSV(e) {
    const archivo = e.target.files?.[0];
    if (!archivo) return;
    setSubiendo(true);
    const datos = new FormData();
    datos.append('archivo', archivo);
    try {
      const res = await api.post('/proveedores/importar-csv/', datos, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      toast.success(`${res.data.creados} proveedor(es) creado(s).`);
      if (res.data.errores?.length) {
        toast.error(`${res.data.errores.length} fila(s) con error: ${res.data.errores.join(' | ')}`);
      }
      cargar();
    } catch {
      toast.error('No se pudo procesar el archivo.');
    } finally {
      setSubiendo(false);
      if (inputArchivoRef.current) inputArchivoRef.current.value = '';
    }
  }

  return (
    <div className="proveedores">
      <div className="control-group">
        <div className="encabezado-con-boton">
          <h4>Proveedores / Beneficiarios</h4>
          {!mostrarForm && (
            <button type="button" className="btn-secundario" onClick={() => { setEditando(null); setMostrarForm(true); }}>
              <Plus size={14} /> Nuevo proveedor
            </button>
          )}
        </div>

        {mostrarForm && (
          <ProveedorForm
            proveedor={editando}
            onGuardado={alGuardar}
            onCancelar={() => { setMostrarForm(false); setEditando(null); }}
          />
        )}

        <div className="carga-masiva">
          <p className="ayuda">Carga masiva por CSV (columnas: nombre, ruc, direccion, telefono, email):</p>
          <div className="acciones-tabla">
            <button type="button" className="btn-secundario" onClick={descargarPlantilla}>
              <Download size={14} /> Descargar plantilla CSV
            </button>
            <button type="button" className="btn-secundario" onClick={() => inputArchivoRef.current?.click()} disabled={subiendo}>
              <Upload size={14} /> {subiendo ? 'Subiendo…' : 'Subir CSV'}
            </button>
            <input ref={inputArchivoRef} type="file" accept=".csv" onChange={subirCSV} style={{ display: 'none' }} />
          </div>
        </div>
      </div>

      <div className="control-group">
        {cargando ? (
          <p>Cargando…</p>
        ) : proveedores.length === 0 ? (
          <p>Todavía no hay proveedores cargados.</p>
        ) : (
          <table className="tabla-historial">
            <thead>
              <tr>
                <th>Nombre</th><th>RUC</th><th>Teléfono</th><th>Email</th><th>Estado</th><th></th>
              </tr>
            </thead>
            <tbody>
              {proveedores.map((p) => (
                <tr key={p.id}>
                  <td>{p.nombre}</td>
                  <td>{p.ruc || '—'}</td>
                  <td>{p.telefono || '—'}</td>
                  <td>{p.email || '—'}</td>
                  <td>{p.activo ? 'Activo' : 'Inactivo'}</td>
                  <td>
                    <div className="acciones-tabla">
                      <button type="button" className="btn-secundario" onClick={() => { setEditando(p); setMostrarForm(true); }}>
                        Editar
                      </button>
                      <button
                        type="button"
                        className={`btn-secundario ${p.activo ? 'btn-peligro' : 'btn-aprobar'}`}
                        onClick={() => alternarActivo(p)}
                      >
                        {p.activo ? 'Desactivar' : 'Activar'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
